<h1 mat-dialog-title class="no-select">
	{{ 'scim-administration.users.detail.title' | translate }}
</h1>
<div mat-dialog-content>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.columns.userName' | translate }}</strong>
		</label>
		<p>{{ user.userName }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.columns.displayName' | translate }}</strong>
		</label>
		<p>{{ user.displayName }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.detail.givenName' | translate }}</strong>
		</label>
		<p>{{ user.name?.givenName }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.detail.familyName' | translate }}</strong>
		</label>
		<p>{{ user.name?.familyName }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.detail.email' | translate }}</strong>
		</label>
		<p>{{ user.emails?.[0]?.value }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.detail.active' | translate }}</strong>
		</label>
		<p>{{ user.active }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.detail.externalId' | translate }}</strong>
		</label>
		<p>{{ user.externalId }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.users.detail.iamUserId' | translate }}</strong>
		</label>
		<p>{{ user.iamUserId }}</p>
	</div>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onClose()">
		{{ 'scim-administration.users.detail.close' | translate }}
	</button>
</div>
